/* atc-native-fallback-20260817 */
/* atc-addjs-20260817 */
/* poster-w400-20260817 */
/* ==========================================================================
   ChicFind theme — storefront interactivity (vanilla JS, no dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || {};
  var strings = theme.strings || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ----------------------------------------------------------- Money format */
  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(value) { return escapeHTML(value).replace(/`/g, '&#96;'); }

  function selectorEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/[^a-zA-Z0-9_-]/g, function (ch) { return '\\' + ch; });
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = theme.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function num(number, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var n = (cents / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = fmt.match(placeholder);
    if (!match) return fmt;
    switch (match[1]) {
      case 'amount': value = num(cents, 2); break;
      case 'amount_no_decimals': value = num(cents, 0); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      default: value = num(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ----------------------------------------------------------------- Toast */
  var toastEl = $('[data-toast]');
  var toastTimer;
  function toast(message) {
    if (!toastEl) return;
    var msg = $('[data-toast-message]', toastEl);
    if (msg) msg.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* -------------------------------------------------------- Overlay + body */
  var overlay = $('[data-overlay]');
  var panelReturnFocus = null;
  function lockScroll() { document.body.classList.add('no-scroll'); }
  function unlockScroll() { document.body.classList.remove('no-scroll'); }
  function showOverlay() { if (overlay) overlay.classList.add('is-open'); }
  function hideOverlay() { if (overlay) overlay.classList.remove('is-open'); }
  function setPanelInteractive(panel, isOpen) {
    if (!panel) return;
    panel.classList.toggle('is-open', isOpen);
    panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (isOpen) panel.removeAttribute('inert');
    else panel.setAttribute('inert', '');
  }

  function closeAllPanels() {
    var mn = $('[data-mobile-nav]'); setPanelInteractive(mn, false);
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var cd = $('[data-cart-drawer]'); setPanelInteractive(cd, false);
    var sm = $('[data-search-modal]'); if (sm) sm.hidden = true;
    $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    hideOverlay(); unlockScroll();
    var returnTo = panelReturnFocus;
    panelReturnFocus = null;
    if (returnTo && document.contains(returnTo)) {
      setTimeout(function () { returnTo.focus(); }, 0);
    }
  }
  if (overlay) overlay.addEventListener('click', closeAllPanels);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllPanels(); });

  /* ------------------------------------------------------------- Header UI */
  var header = $('[data-header]');
  if (header) {
    var headerWrap = $('[data-header-wrap]');
    if (headerWrap) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --------------------------------------------------------- Mobile nav */
  var mobileNav = $('[data-mobile-nav]');
  function openMobileNav(trigger) {
    if (!mobileNav) return;
    panelReturnFocus = trigger || document.activeElement;
    setPanelInteractive(mobileNav, true);
    $$('[data-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    showOverlay();
    lockScroll();
    var close = $('[data-menu-close]', mobileNav);
    if (close) setTimeout(function () { close.focus(); }, 0);
  }
  $$('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { openMobileNav(b); });
  });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeAllPanels); });

  /* ------------------------------------------------------------- Search */
  var searchModal = $('[data-search-modal]');
  $$('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (!searchModal) return;
      e.preventDefault();
      panelReturnFocus = b;
      searchModal.hidden = false;
      b.setAttribute('aria-expanded', 'true');
      showOverlay();
      lockScroll();
      var input = $('input[type="search"]', searchModal);
      if (input) setTimeout(function () { input.focus(); }, 50);
    });
  });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeAllPanels); });

  /* ============================================================ CART AJAX */
  var cartDrawer = $('[data-cart-drawer]');
  var cartAddPending = false;
  var latestCart = null;
  var PWF_PRODUCT_ID = '8013541244971';
  var PWF_VARIANT_IDS = ['44443337883691', '44443337949227'];
  var checkoutRedirectPending = false;

  function cartHasPwf(cart) {
    return !!(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      var variantId = String(item.variant_id || item.id || '');
      return String(item.product_id || '') === PWF_PRODUCT_ID && PWF_VARIANT_IDS.indexOf(variantId) !== -1;
    }));
  }

  function pwfDiscountCheckoutUrl(code) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }

  function syncCartCheckoutOffer(cart) {
    var hasPwf = cart
      ? cartHasPwf(cart)
      : $$('[data-checkout][data-pwf-cart-present="true"]').length > 0;
    $$('[data-checkout]').forEach(function (link) {
      link.setAttribute('data-pwf-cart-present', hasPwf ? 'true' : 'false');
    });

    $$('[data-pwf-checkout-note]').forEach(function (note) {
      note.hidden = !hasPwf;
      if (!hasPwf) return;
      note.textContent = 'WELCOME10 is applied at checkout for eligible first orders.';
    });
  }

  function setCartPending(message) {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-updating');
    var status = $('[data-cart-status]', cartDrawer);
    if (status) {
      status.textContent = message || 'Updating cart totals…';
      status.hidden = false;
    }
    var foot = $('[data-cart-foot]', cartDrawer);
    if (foot) foot.setAttribute('aria-busy', 'true');
    var checkout = $('[data-checkout]', cartDrawer);
    if (checkout) {
      checkout.setAttribute('aria-disabled', 'true');
      checkout.setAttribute('tabindex', '-1');
    }
  }

  function maybeClearCartPending() {
    if (!cartDrawer || cartAddPending || Object.keys(cartChangeStates || {}).length) return;
    cartDrawer.classList.remove('is-updating');
    var status = $('[data-cart-status]', cartDrawer);
    if (status) {
      status.hidden = true;
      status.textContent = '';
    }
    var foot = $('[data-cart-foot]', cartDrawer);
    if (foot) foot.removeAttribute('aria-busy');
    var checkout = $('[data-checkout]', cartDrawer);
    if (checkout) {
      checkout.removeAttribute('aria-disabled');
      checkout.removeAttribute('tabindex');
    }
  }

  function openCartDrawer(trigger) {
    if (!cartDrawer) return;
    if (trigger) panelReturnFocus = trigger;
    setPanelInteractive(cartDrawer, true);
    showOverlay();
    lockScroll();
    var close = $('[data-cart-close]', cartDrawer);
    if (close) setTimeout(function () { close.focus(); }, 0);
  }
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (!cartDrawer) return; // fall back to /cart link
      e.preventDefault();
      openCartDrawer(b);
    });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeAllPanels); });

  function cartAjaxUrl(path) {
    var p = path || '';
    return p.indexOf('.js') === -1 ? p + '.js' : p;
  }

  function addToCart(body, button) {
    var original = button ? button.querySelector('[data-atc-text]') : null;
    var label = original ? original.textContent : '';
    var addConfirmed = false;
    if (body && body.items && body.items[0]) {
      body.items[0].id = parseInt(body.items[0].id, 10);
    }
    if (button) { button.disabled = true; if (original) original.textContent = strings.adding || 'Adding…'; }
    cartAddPending = true;
    openCartDrawer(button);
    setCartPending(strings.adding || 'Adding to cart…');

    return fetch(cartAjaxUrl(theme.routes && theme.routes.cartAdd), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.text().then(function (t) {
          var d = null;
          try { d = JSON.parse(t); } catch (err) { d = null; }
          var errStatus = d && typeof d.status === 'number' && d.status >= 400;
          var added = !!(d && (d.variant_id || d.id || (d.items && d.items.length)));
          var ok = !!(r.ok && d && !errStatus && added);
          return { ok: ok, data: d };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          toast((res.data && res.data.description) || 'Could not add to cart');
          return { ok: false };
        }
        addConfirmed = true;
        return refreshCart().then(function (cart) {
          if (!cart || !cart.item_count) return { ok: false };
          openCartDrawer();
          toast(strings.addedToCart || 'Added to cart');
          return { ok: true, cart: cart };
        });
      })
      .catch(function () {
        if (addConfirmed) {
          toast('Item added. Cart totals could not refresh — reopen the cart to retry.');
          return { ok: true, refreshFailed: true };
        }
        toast('Network error — please try again');
        return { ok: false };
      })
      .finally(function () {
        cartAddPending = false;
        maybeClearCartPending();
        if (button) { button.disabled = false; if (original) original.textContent = label; }
      });
  }

  function applyCart(cart) {
    if (!cart || typeof cart.item_count !== 'number') throw new Error('Invalid cart response');
    latestCart = cart;
    renderCart(cart);
    renderCartPage(cart);
    syncCartCheckoutOffer(cart);
    updateCartCount(cart.item_count);
    return cart;
  }

  function requestQtyChange(key, quantity) {
    return fetch(cartAjaxUrl(theme.routes && theme.routes.cartChange), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart update failed');
      return r.json();
    });
  }

  var cartChangeStates = Object.create(null);

  function setOptimisticCartQuantity(key, quantity) {
    setCartPending(quantity === 0 ? 'Removing item…' : 'Updating cart totals…');
    var selector = '[data-qty-input][data-key="' + selectorEscape(key) + '"]';
    $$(selector).forEach(function (input) { input.value = quantity; });
    $$('[data-line-key="' + selectorEscape(key) + '"]').forEach(function (line) {
      line.setAttribute('aria-busy', 'true');
    });
  }

  function clearCartLinePending(key) {
    $$('[data-line-key="' + selectorEscape(key) + '"]').forEach(function (line) {
      line.removeAttribute('aria-busy');
    });
  }

  function restoreCartControlFocus(key, action) {
    if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;
    var line = $('[data-line-key="' + selectorEscape(key) + '"]', cartDrawer);
    var selector = action === 'up' ? '[data-qty-up]' : action === 'down' ? '[data-qty-down]' : action === 'input' ? '[data-qty-input]' : '';
    var target = line && selector ? $(selector, line) : null;
    if (!target) target = $('[data-cart-close]', cartDrawer);
    if (target) setTimeout(function () { target.focus(); }, 0);
  }

  function flushQtyChange(key) {
    var state = cartChangeStates[key];
    if (!state || state.inFlight) return;

    var sentQuantity = state.desired;
    state.inFlight = true;

    requestQtyChange(key, sentQuantity)
      .then(function (cart) {
        // A newer click can arrive while this request is running. Only render
        // the response when it still represents the latest requested quantity.
        if (state.desired === sentQuantity) {
          applyCart(cart);
          restoreCartControlFocus(key, state.focusAction);
        }
      })
      .catch(function () {
        toast('Could not update cart — please try again');
        return refreshCart().catch(function () {});
      })
      .finally(function () {
        state.inFlight = false;
        if (state.desired !== sentQuantity) {
          flushQtyChange(key);
        } else {
          delete cartChangeStates[key];
          clearCartLinePending(key);
          maybeClearCartPending();
        }
      });
  }

  function changeQty(key, quantity, focusAction) {
    quantity = Math.max(0, parseInt(quantity, 10) || 0);
    var state = cartChangeStates[key];
    if (!state) {
      state = { desired: quantity, inFlight: false, timer: null, focusAction: focusAction || '' };
      cartChangeStates[key] = state;
    }

    state.desired = quantity;
    state.focusAction = focusAction || state.focusAction || '';
    setOptimisticCartQuantity(key, quantity);
    if (state.timer) clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      state.timer = null;
      flushQtyChange(key);
    }, 120);
  }

  function refreshCart() {
    return fetch(theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'include' })
      .then(function (r) { return r.json(); })
      .then(applyCart);
  }


  function cartPriceHTML(item) {
    var finalPrice = formatMoney(item.final_line_price);
    var originalPrice = typeof item.original_line_price === 'number' ? item.original_line_price : item.final_line_price;
    var discounted = originalPrice > item.final_line_price;
    var titles = (item.line_level_discount_allocations || []).map(function (allocation) {
      return allocation && allocation.discount_application ? allocation.discount_application.title : '';
    }).filter(Boolean);
    if (!discounted) return '<span>' + finalPrice + '</span>';
    return '<s>' + formatMoney(originalPrice) + '</s>' +
      '<span>' + finalPrice + '</span>' +
      (titles.length ? '<small class="cart-line__discount">' + escapeHTML(titles.join(', ')) + '</small>' : '');
  }

  function cartPageRowHTML(item) {
    var key = escapeAttr(item.key);
    var url = escapeAttr(item.url || '#');
    var title = escapeHTML(item.product_title || item.title || '');
    var imgUrl = item.image ? escapeAttr(item.image.replace(/(\.[^.]+)(\?|$)/, '_200x$1$2')) : '';
    var img = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '';
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
      ? '<div class="cart-line__variant">' + escapeHTML(item.variant_title) + '</div>' : '';
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? '<div class="cart-line__variant">' + escapeHTML(item.selling_plan_allocation.selling_plan.name) + '</div>' : '';
    return '' +
      '<div class="cart-row" data-line-key="' + key + '">' +
        '<a href="' + url + '" class="cart-row__img">' + img + '</a>' +
        '<div class="cart-row__info">' +
          '<a href="' + url + '" class="cart-line__title">' + title + '</a>' +
          variant + plan +
          '<button type="button" class="cart-line__remove" data-remove data-key="' + key + '">' + escapeHTML(strings.remove || 'Remove') + '</button>' +
        '</div>' +
        '<div class="qty qty--sm">' +
          '<button type="button" data-qty-down data-key="' + key + '" aria-label="Decrease">&minus;</button>' +
          '<input type="text" value="' + item.quantity + '" data-qty-input data-key="' + key + '" inputmode="numeric" aria-label="Quantity">' +
          '<button type="button" data-qty-up data-key="' + key + '" aria-label="Increase">+</button>' +
        '</div>' +
        '<div class="cart-row__price">' + cartPriceHTML(item) + '</div>' +
      '</div>';
  }

  function renderCartPage(cart) {
    var form = $('[data-cart-page-form]');
    if (!form) return;
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }
    form.innerHTML = cart.items.map(cartPageRowHTML).join('');
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
    var label = $('[data-cart-count-label]'); if (label) label.textContent = '(' + count + ')';
  }

  function cartLineHTML(item) {
    var key = escapeAttr(item.key);
    var url = escapeAttr(item.url || '#');
    var title = escapeHTML(item.product_title || item.title || '');
    var imgUrl = item.image ? escapeAttr(item.image.replace(/(\.[^.]+)(\?|$)/, '_150x$1$2')) : '';
    var img = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '';
    var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
      ? '<div class="cart-line__variant">' + escapeHTML(item.variant_title) + '</div>' : '';
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
      ? '<div class="cart-line__variant">' + escapeHTML(item.selling_plan_allocation.selling_plan.name) + '</div>' : '';
    return '' +
      '<div class="cart-line" data-line-key="' + key + '">' +
        '<a href="' + url + '" class="cart-line__img">' + img + '</a>' +
        '<div class="cart-line__details">' +
          '<a href="' + url + '" class="cart-line__title">' + title + '</a>' +
          variant + plan +
          '<div class="qty qty--sm" style="margin-top:.5rem">' +
            '<button type="button" data-qty-down data-key="' + key + '" aria-label="Decrease">&minus;</button>' +
            '<input type="text" value="' + item.quantity + '" data-qty-input data-key="' + key + '" inputmode="numeric" aria-label="Quantity">' +
            '<button type="button" data-qty-up data-key="' + key + '" aria-label="Increase">+</button>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-remove data-key="' + key + '">' + escapeHTML(strings.remove || 'Remove') + '</button>' +
        '</div>' +
        '<div class="cart-line__price">' + cartPriceHTML(item) + '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    var body = $('[data-cart-body]', cartDrawer);
    var foot = $('[data-cart-foot]', cartDrawer);
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty" data-cart-empty><svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1.4"/><circle cx="19" cy="21" r="1.4"/><path d="M2.5 3h2.2l2.2 12.2a1.8 1.8 0 0 0 1.8 1.5h8.7a1.8 1.8 0 0 0 1.8-1.4L22 7H6"/></svg><p>' + (strings.cartEmpty || 'Your cart is empty.') + '</p></div>';
      if (foot) foot.setAttribute('hidden', '');
    } else {
      body.innerHTML = cart.items.map(cartLineHTML).join('');
      if (foot) foot.removeAttribute('hidden');
      var sub = $('[data-cart-subtotal]', cartDrawer);
      if (sub) sub.textContent = formatMoney(cart.total_price);
    }
    updateCartOffer(cart);
    updateShippingBar(cart);
  }

  function updateCartOffer(cart) {
    if (!cartDrawer || !cart) return;
    var note = $('[data-cart-offer-note]', cartDrawer);
    if (!note) return;
    var coolingHandle = 'nwk-pet-cooling-mat-20-x-16-ice-silk-cooling-mat-for-dogs-cats-portable-washable-pet-cooling-blanket-car-seats-beds-for-summer-blue-toy-small';
    var hasCooling = (cart.items || []).some(function (item) { return item.handle === coolingHandle; });
    note.hidden = !hasCooling;
  }

  function updateShippingBar(cart) {
    if (!cartDrawer || !cart) return;
    var shippingEnabled = cartDrawer.getAttribute('data-free-shipping-enabled') === 'true';
    var threshold = parseInt(cartDrawer.getAttribute('data-threshold'), 10) || 0;
    var items = Array.isArray(cart.items) ? cart.items : [];
    var requiresShipping = items.some(function (item) { return item.requires_shipping; });
    var hasPwf = cartHasPwf(cart);
    var bars = $$('[data-shipping-bar]');
    var physicalNote = $('[data-cart-physical-note]', cartDrawer);
    var digitalNote = $('[data-cart-digital-note]', cartDrawer);

    cartDrawer.setAttribute('data-cart-requires-shipping', requiresShipping ? 'true' : 'false');
    bars.forEach(function (bar) {
      bar.hidden = !(shippingEnabled && requiresShipping && threshold > 0);
    });
    if (physicalNote) {
      physicalNote.hidden = !requiresShipping;
      if (requiresShipping) {
        physicalNote.textContent = hasPwf
          ? 'Free U.S. standard shipping is included for the fountain. Taxes, if applicable, are calculated at checkout.'
          : (physicalNote.getAttribute('data-default-text') || strings.taxesNote || 'Shipping and taxes are calculated at checkout.');
      }
    }
    if (digitalNote) digitalNote.hidden = requiresShipping;

    if (!shippingEnabled || !requiresShipping || !bars.length || threshold <= 0) return;
    bars.forEach(function (bar) {
      var msg = $('[data-shipping-message]', bar);
      var fill = $('.cart-progress-bar span', bar);
      var pct = hasPwf ? 100 : Math.min(100, (cart.total_price / threshold) * 100);
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        if (hasPwf) {
          msg.textContent = 'Free U.S. standard shipping is included for the fountain.';
        } else if (cart.total_price >= threshold) {
          msg.innerHTML = (strings.freeShippingUnlocked || "You've unlocked free shipping!");
        } else {
          var remaining = formatMoney(threshold - cart.total_price);
          msg.innerHTML = (strings.freeShippingRemaining || "You're [amount] away from free shipping").replace('[amount]', '<strong>' + remaining + '</strong>');
        }
      }
    });
  }

  syncCartCheckoutOffer(null);

  // Delegated cart interactions
  document.addEventListener('click', function (e) {
    var checkout = e.target.closest('[data-checkout]');
    if (checkout && checkout.getAttribute('data-pwf-cart-present') === 'true') {
      e.preventDefault();
      if (checkoutRedirectPending || checkout.getAttribute('aria-disabled') === 'true') return;

      checkoutRedirectPending = true;
      checkout.setAttribute('aria-disabled', 'true');
      var fallbackUrl = checkout.getAttribute('data-default-checkout-url') || checkout.href || '/checkout';

      fetch(theme.routes.cart + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'include',
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart read failed');
          return response.json();
        })
        .then(function (cart) {
          applyCart(cart);
          window.location.assign(cartHasPwf(cart)
            ? pwfDiscountCheckoutUrl('WELCOME10')
            : fallbackUrl);
        })
        .catch(function () {
          window.location.assign(fallbackUrl);
        });
      return;
    }

    var add = e.target.closest('[data-quick-add]');
    if (add) { e.preventDefault(); addToCart({ items: [{ id: add.getAttribute('data-variant-id'), quantity: 1 }] }, add); return; }

    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    var remove = e.target.closest('[data-remove]');
    if (up || down || remove) {
      e.preventDefault();
      var trigger = up || down || remove;
      var key = trigger.getAttribute('data-key');
      var line = trigger.closest('[data-line-key]');
      var input = line ? $('[data-qty-input]', line) : $('[data-qty-input][data-key="' + selectorEscape(key) + '"]');
      var current = input ? parseInt(input.value, 10) : 1;
      if (remove) { changeQty(key, 0, 'remove'); }
      else if (up) { changeQty(key, current + 1, 'up'); }
      else if (down) { changeQty(key, Math.max(0, current - 1), 'down'); }
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) {
      var q = Math.max(0, parseInt(input.value, 10) || 0);
      changeQty(input.getAttribute('data-key'), q, 'input');
    }
  });

  // Cart page: persist the order note via AJAX
  var cartNote = $('[data-cart-note]');
  if (cartNote) {
    cartNote.addEventListener('change', function () {
      fetch(theme.routes.cart + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: cartNote.value })
      }).catch(function () {});
    });
  }

  /* ====================================================== PRODUCT PAGE */
  var productForm = $('[data-product-form]');
  if (productForm) {
    var section = productForm.closest('[data-product-section]');
    var variantsScript = $('[data-variant-json]', section);
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
    var idInput = $('[data-variant-id]', productForm);
    var planInput = $('[data-selling-plan-input]', productForm);
    var atc = $('[data-atc]', productForm);
    var atcText = $('[data-atc-text]', productForm);
    var priceWrap = $('[data-price-wrap]', section);
    var stickyPrice = $('[data-sticky-price]');
    var inventoryWrap = $('[data-inventory]', section);
    var inventoryText = $('[data-inventory-text]', section);
    var compareAtVerified = section && section.getAttribute('data-compare-at-verified') === 'true';

    function selectedOptions() {
      var opts = [];
      $$('[data-option-input]', productForm).forEach(function (input) {
        if (input.checked) opts[parseInt(input.getAttribute('data-option-position'), 10)] = input.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function priceHTML(v) {
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      var html = '<span class="price' + (onSale ? ' price--on-sale' : '') + '">';
      html += '<span class="price__regular">' + formatMoney(v.price) + '</span>';
      if (onSale) html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
      html += '</span>';
      if (onSale) html += ' <span class="badge badge--sale">' + (strings.save || 'Save') + ' ' + formatMoney(v.compare_at_price - v.price) + '</span>';
      return html;
    }

    function updateAvailability() {
      // disable option values that have no available variant given current selection
      var groups = $$('[data-option-index]', productForm);
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        $$('[data-option-input]', group).forEach(function (input) {
          var test = selectedOptions();
          test[idx] = input.value;
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return i === idx ? o === input.value : (test[i] ? o === test[i] : true); });
          });
          // Do not disable a checked radio — some Android WebViews uncheck
          // display:none / disabled radios and then ATC looks dead.
          if (!input.checked) input.disabled = !(match && match.available);
        });
      });
    }

    var isInitialVariantSync = true;

    function onVariantChange() {
      var opts = selectedOptions();
      var v = findVariant(opts);

      // selected value labels
      opts.forEach(function (val, i) { var lbl = $('[data-selected-option="' + i + '"]', section); if (lbl) lbl.textContent = val; });

      if (!v) {
        var existingId = parseInt(idInput && idInput.value, 10);
        if (existingId) {
          if (atc) atc.disabled = false;
          if (atcText) atcText.textContent = strings.addToCart || 'Add to cart';
          var stickyKeep = $('[data-sticky-add]');
          if (stickyKeep) stickyKeep.disabled = false;
        } else {
          if (atc) atc.disabled = true;
          if (atcText) atcText.textContent = strings.unavailable || 'Unavailable';
          $$('[data-direct-checkout]').forEach(function (b) { b.disabled = true; });
        }
        return;
      }
      if (idInput) idInput.value = v.id;

      // price
      if (priceWrap) priceWrap.innerHTML = priceHTML(v);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(v);

      // availability
      if (atc) atc.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      var stickyAdd = $('[data-sticky-add]'); if (stickyAdd) stickyAdd.disabled = !v.available;
      $$('[data-direct-checkout]').forEach(function (b) { b.disabled = !v.available; });

      // inventory
      if (inventoryText) {
        if (v.available && section.classList.contains('product-pwf-fast-checkout')) {
          inventoryText.textContent = 'In stock — shipping options and estimated timing are shown at checkout for your address';
        } else {
          inventoryText.textContent = v.available ? (strings.inStock || 'In stock') : (strings.soldOut || 'Sold out');
        }
      }

      // Keep the product demo visible on first load; later color changes can show the selected variant image.
      if (v.featured_media && !(isInitialVariantSync && $('[data-pwf-hero-video]', section))) activateMedia(v.featured_media.id);
      isInitialVariantSync = false;

      // URL
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      updateAvailability();
    }

    $$('[data-option-input]', productForm).forEach(function (i) { i.addEventListener('change', onVariantChange); });
    onVariantChange();

    // Subscribe & save toggle
    var buyOptions = $('[data-buy-options]', productForm);
    if (buyOptions && planInput) {
      function syncPlan() {
        var checked = $('input[name="purchase_type"]:checked', buyOptions);
        var plan = checked ? checked.getAttribute('data-selling-plan') : '';
        var sel = $('[data-selling-plan-select]', buyOptions);
        if (checked && checked.value === 'subscribe' && sel) plan = sel.value;
        planInput.value = plan || '';
      }
      $$('input[name="purchase_type"]', buyOptions).forEach(function (r) { r.addEventListener('change', syncPlan); });
      var planSel = $('[data-selling-plan-select]', buyOptions);
      if (planSel) planSel.addEventListener('change', syncPlan);
      syncPlan();
    }

    // Quantity steppers
    var qtyField = $('[data-qty-field]', productForm);
    var minus = $('[data-qty-minus]', productForm);
    var plus = $('[data-qty-plus]', productForm);
    if (minus) minus.addEventListener('click', function () { qtyField.value = Math.max(1, (parseInt(qtyField.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { qtyField.value = (parseInt(qtyField.value, 10) || 1) + 1; });

    // Submit → AJAX /cart/add.js; use native POST only before an AJAX request is sent
    var nativeFallback = false;
    var submitting = false;
    productForm.setAttribute('novalidate', 'novalidate');
    function nativeSubmitCart() {
      nativeFallback = true;
      if (planInput && !planInput.value) planInput.disabled = true;
      HTMLFormElement.prototype.submit.call(productForm);
    }
    productForm.addEventListener('submit', function (e) {
      var submitter = e.submitter || document.activeElement;
      var isDynamicCheckout = submitter && (
        submitter.name === 'shopify-payment-button' ||
        (submitter.closest && submitter.closest('.shopify-payment-button'))
      );
      if (isDynamicCheckout || !cartDrawer || nativeFallback) return;
      e.preventDefault();
      if (submitting) return;
      if (typeof fetch !== 'function') { nativeSubmitCart(); return; }
      var button = (submitter && submitter.matches && submitter.matches('[data-sticky-add]')) ? submitter : atc;
      var vid = parseInt(idInput && idInput.value, 10);
      if (!vid) { nativeSubmitCart(); return; }
      var body = {
        items: [{
          id: vid,
          quantity: parseInt(qtyField ? qtyField.value : 1, 10) || 1
        }]
      };
      if (planInput && planInput.value) body.items[0].selling_plan = planInput.value;
      submitting = true;
      addToCart(body, button).then(function () {
        submitting = false;
      });
    });
    $$('[data-sticky-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!productForm) return;
        e.preventDefault();
        if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit(btn);
        else productForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });

    $$('[data-direct-checkout]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (submitting || typeof fetch !== 'function') return;
        var vid = parseInt(idInput && idInput.value, 10);
        if (!vid) return;
        var label = $('[data-direct-checkout-text]', btn);
        var originalLabel = label ? label.textContent : 'Buy now';
        var item = {
          id: vid,
          quantity: parseInt(qtyField ? qtyField.value : 1, 10) || 1
        };
        if (planInput && planInput.value) item.selling_plan = planInput.value;
        submitting = true;
        btn.disabled = true;
        if (label) label.textContent = 'Opening checkout…';

        fetch(cartAjaxUrl(theme.routes && theme.routes.cartAdd), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ items: [item] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart add failed');
            var discountCode = btn.getAttribute('data-discount-code');
            var checkoutUrl = discountCode
              ? '/discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout'
              : '/checkout';
            window.location.assign(checkoutUrl);
          })
          .catch(function () {
            submitting = false;
            btn.disabled = false;
            if (label) label.textContent = originalLabel;
            toast('Could not open checkout. Please use Add to cart.');
          });
      });
    });
  }

  /* ----------------------------------------------------------- Gallery */
  function activateMedia(mediaId) {
    var gallery = $('[data-gallery]');
    if (!gallery) return;
    $$('[data-slide]', gallery).forEach(function (s) {
      var on = s.getAttribute('data-media-id') === String(mediaId);
      s.classList.toggle('is-active', on);
      var vid = s.querySelector('video');
      if (!vid) return;
      if (on) {
        var poster = vid.getAttribute('data-poster') || s.getAttribute('data-poster');
        if (poster && !vid.getAttribute('poster')) vid.setAttribute('poster', poster);
        var sources = vid.querySelectorAll('source[data-src]');
        for (var si = 0; si < sources.length; si++) {
          if (!sources[si].getAttribute('src')) sources[si].setAttribute('src', sources[si].getAttribute('data-src'));
        }
        if (sources.length) vid.load();
        if (vid.hasAttribute('autoplay')) {
          var playAttempt = vid.play();
          if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
        }
      } else if (!vid.paused) {
        vid.pause();
      }
    });
    $$('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-media-id') === String(mediaId)); });
  }
  $$('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () { activateMedia(thumb.getAttribute('data-media-id')); });
  });
  var initialMedia = $('[data-gallery] [data-slide].is-active');
  if (initialMedia) activateMedia(initialMedia.getAttribute('data-media-id'));

  /* ----------------------------------------------------- Sticky add-to-cart */
  var stickyAtcBar = $('[data-sticky-atc]');
  var mainAtc = $('[data-atc]');
  var forcePwfMobileSticky = stickyAtcBar &&
    stickyAtcBar.classList.contains('sticky-atc--pwf-fast') &&
    window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  if (forcePwfMobileSticky) {
    stickyAtcBar.classList.add('is-visible');
    stickyAtcBar.setAttribute('aria-hidden', 'false');
    stickyAtcBar.removeAttribute('inert');
  }
  if (!forcePwfMobileSticky && stickyAtcBar && mainAtc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyAtcBar.classList.toggle('is-visible', shouldShow);
        stickyAtcBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        if (shouldShow) stickyAtcBar.removeAttribute('inert');
        else stickyAtcBar.setAttribute('inert', '');
      });
    }, { rootMargin: '0px' });
    io.observe(mainAtc);
  }

  /* ---------------------------------------------------------- Size guide */
  var sizeGuide = $('[data-size-guide]');
  $$('[data-size-guide-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); if (sizeGuide) { sizeGuide.hidden = false; lockScroll(); } }); });
  $$('[data-size-guide-close]').forEach(function (b) { b.addEventListener('click', function () { if (sizeGuide) { sizeGuide.hidden = true; unlockScroll(); } }); });
  if (sizeGuide) sizeGuide.addEventListener('click', function (e) { if (e.target === sizeGuide) { sizeGuide.hidden = true; unlockScroll(); } });

  /* ---------------------------------------------------------- Accordions */
  $$('[data-accordion] .accordion__trigger').forEach(function (trigger) {
    var controls = trigger.getAttribute('aria-controls');
    var panel = controls ? document.getElementById(controls) : trigger.nextElementSibling;
    if (trigger.getAttribute('aria-expanded') === 'true' && panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
    });
  });

  /* ------------------------------------------------------ Announcement bar */
  var annTrack = $('[data-announcement-track]');
  if (annTrack) {
    var slides = $$('[data-announcement-slide]', annTrack);
    if (slides.length <= 1) { annTrack.setAttribute('data-single', ''); }
    else {
      var idx = 0; slides[0].classList.add('is-active');
      setInterval(function () {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, 4000);
    }
  }

  /* ----------------------------------------------------- Collection sort/filter */
  var sortSelect = $('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  var filtersToggle = $('[data-filters-toggle]');
  var filtersForm = $('[data-filters]');
  if (filtersToggle && filtersForm) {
    filtersToggle.addEventListener('click', function () {
      var open = !filtersForm.hidden;
      filtersForm.hidden = open;
      filtersToggle.setAttribute('aria-expanded', String(!open));
    });
    $$('[data-filter-input]', filtersForm).forEach(function (input) {
      input.addEventListener('change', function () {
        var params = new URLSearchParams();
        $$('[data-filter-input]', filtersForm).forEach(function (i) {
          if ((i.type === 'checkbox' && i.checked) || (i.type === 'number' && i.value)) params.append(i.name, i.value);
        });
        if (sortSelect) params.set('sort_by', sortSelect.value);
        window.location.search = params.toString();
      });
    });
  }

  /* ------------------------------------------------ Product recommendations */
  function setRecsVisibility(el, visible) {
    if (!el) return;
    var wrap = el.closest ? el.closest('.shopify-section') : null;
    if (visible) {
      el.removeAttribute('hidden');
      el.style.removeProperty('display');
      if (wrap) { wrap.removeAttribute('hidden'); wrap.style.removeProperty('display'); }
    } else {
      el.setAttribute('hidden', '');
      if (wrap) wrap.setAttribute('hidden', '');
    }
  }
  var recs = $('[data-product-recommendations]');
  if (recs && recs.getAttribute('data-url')) {
    fetch(recs.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var incoming = html.querySelector('[data-product-recommendations]');
        if (!incoming) { setRecsVisibility(recs, false); return; }
        var grid = incoming.querySelector('[data-recs-grid]') || incoming.querySelector('.product-grid');
        if (!grid || !grid.children.length) { setRecsVisibility(recs, false); return; }
        var current = recs.querySelector('[data-recs-grid]') || recs.querySelector('.product-grid');
        if (current) {
          current.replaceWith(grid);
          var hdr = incoming.querySelector('.section-header');
          var curHdr = recs.querySelector('.section-header');
          if (hdr && curHdr) curHdr.replaceWith(hdr);
        } else {
          recs.innerHTML = incoming.innerHTML;
        }
        setRecsVisibility(recs, true);
      })
      .catch(function () { setRecsVisibility(recs, false); });
  } else if (recs) {
    var existingGrid = recs.querySelector('[data-recs-grid]') || recs.querySelector('.product-grid');
    if (!existingGrid || !existingGrid.children.length) setRecsVisibility(recs, false);
  }

  /* -------------------------------------------------------- Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var revealIO = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('[data-reveal]').forEach(function (el) { revealIO.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ----------------------------------------------------------- Smooth anchor */
  $$('[data-scroll-to]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector(link.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  // Only resync when the browser restores a cached page.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && cartDrawer) refreshCart().catch(function () {});
  });
})();
